import { render, staticRenderFns } from "./unionConfigs.vue?vue&type=template&id=4a250416&"
import script from "./unionConfigs.vue?vue&type=script&lang=js&"
export * from "./unionConfigs.vue?vue&type=script&lang=js&"
import style0 from "./unionConfigs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionConfigs.vue"
export default component.exports